<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="busInformations"
      class="elevation-1"
      :loading="loading"
      loading-text="Đang Tải"
      :server-items-length="totalItems"
      no-data-text="Không có dữ liệu"
      disableSort
      hide-default-footer
    >
      <template v-slot:[`item.driverLicense`]="{ item }">
        {{ convertText(item.driverLicense) }}
      </template>
      <template v-slot:[`item.resume`]="{ item }">
        {{ convertText(item.resume) }}
      </template>
      <template v-slot:[`item.healthCertificate`]="{ item }">
        {{ convertText(item.healthCertificate) }}
      </template>
      <template v-slot:[`item.note`]="{ item }">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <div v-on="on" class="note">
              {{ item.note }}
            </div>
          </template>
          <div class="tooltip">
            {{ item.note }}
          </div>
        </v-tooltip>
      </template>
    </v-data-table>
    <table class="freeze-table">
      <thead>
        <tr class="header-table">
          <th>Thao tác</th>
        </tr>
      </thead>
      <tbody>
        <tr class="content-action border-b" v-for="item in busInformations" :key="item.id">
          <td>
            <div class="d-flex align-center justify-center">
              <v-btn icon @click="() => $refs['dialog-view-bus-info'].openDialog(item)">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title
                      class="primary--text"
                      style="cursor: pointer"
                      @click="() => $refs['dialog-bus-info'].openDialog('update', item)"
                      >SỬA</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title class="error--text" style="cursor: pointer" @click="() => deleteBusInfo(item)"
                      >XOÁ</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="freeze-table-left">
      <thead>
        <tr class="header-table text-left">
          <th><span class="ml-3">Tên xe tuyến</span></th>
        </tr>
      </thead>
      <tbody>
        <tr class="content-action border-b" v-for="item in busInformations" :key="item.id">
          <td>
            <div class="ml-4">{{ item.stt }}</div>
          </td>
        </tr>
      </tbody>
    </table>

    <DialogBusInfo ref="dialog-bus-info" />
    <DialogViewBusInfo ref="dialog-view-bus-info" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DialogBusInfo from '@/modules/bus/bus-manager/DialogBusInfo.vue'
import DialogViewBusInfo from './DialogViewBusInfo.vue'
import { headers } from './helper'
export default {
  components: {
    DialogBusInfo,
    DialogViewBusInfo
  },
  data() {
    return {
      headers,
      pagination: {}
    }
  },
  created() {
    this.fetch({})
    this.count({})
  },
  computed: {
    ...mapState({
      busInformations: state => state.busInformation.busInformations,
      totalItems: state => state.busInformation.totalItems,
      loading: state => state.busInformation.loading
    })
  },
  methods: {
    ...mapActions({
      fetch: 'busInformation/fetch',
      count: 'busInformation/count',
      delete: 'busInformation/delete'
    }),
    deleteBusInfo(item) {
      this.$dialog.confirm({
        title: 'Xác nhận xoá xe tuyến',
        text: 'Xác nhận xoá xe tuyến này?',
        type: 'delete',
        done: async () => {
          try {
            this.$loading.active = true
            await this.delete(item.id)
            this.fetch({})
            this.$alert.success('Xóa xe tuyến thành công')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        },
        okText: 'Xác nhận',
        cancelText: 'Hủy'
      })
    },
    convertText(type) {
      return type == true ? 'Đủ' : 'Chưa có'
    }
  }
}
</script>

<style lang="scss" scoped>
.note {
  overflow: hidden;
  width: 200px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.tooltip {
  max-width: 300px;
}
.relative {
  position: relative;
}
.freeze-table {
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  background-color: white;
  border-collapse: collapse;
}
.freeze-table-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 120px;
  background-color: white;
  border-collapse: collapse;
}
.header-table {
  height: 47px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
  background-color: rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.text-left {
  text-align: left;
}
.content-action {
  height: 48px;
}
.border-b {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
